import { Modal } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  SLABCLOUD_ORIGIN,
  VISUALIZER_IFRAME_ID,
} from './ColorVizContent.types';
import { useVisualizerMessage } from './hooks/useVisualizerMessage';

import { ColorModel } from '~/core/models';

export interface ColorVizContentProps {
  showColorVisualizer: boolean;
  selectedColor?: ColorModel;
  setShowColorVisualizer: (showColorVisualizer: boolean) => void;
  setColorVizImage: (colorVizImage: string) => void;
  colorVizName: string;
  setColorVizName: (colorVizName: string) => void;
  showColorModal: () => void;
}

const ColorVizContent = ({
  showColorVisualizer,
  selectedColor,
  setShowColorVisualizer,
  setColorVizImage,
  colorVizName,
  setColorVizName,
  showColorModal,
}: ColorVizContentProps): JSX.Element | null => {
  const { t } = useTranslation();

  const handleColorChange = useCallback(
    (screenshotImg: string, newColorName: string) => {
      setColorVizImage(screenshotImg);
      setColorVizName(newColorName);
      showColorModal();
    },
    [setColorVizImage, setColorVizName, showColorModal]
  );

  const handleClose = useCallback(() => {
    setShowColorVisualizer(false);
  }, [setShowColorVisualizer]);

  const { requestScreenshot } = useVisualizerMessage({
    selectedColorName: selectedColor?.name,
    colorVizName,
    onColorChange: handleColorChange,
    onClose: handleClose,
  });

  if (!showColorVisualizer) {
    return null;
  }

  return (
    <Modal
      className="visualizer-modal"
      open={showColorVisualizer}
      onCancel={requestScreenshot}
      width="auto"
      centered
      footer={null}
      title={t('SCROLLABLE_AREA.COLOR.VISUALIZE')}
      closable
    >
      <div className="modal-content">
        <div id="visualizer-container">
          {selectedColor ? (
            <iframe
              title="roomvo-visualizer"
              allowFullScreen
              width="1200"
              height="800"
              src={`${SLABCLOUD_ORIGIN}/visualizer3d/?company=inscyth&stone_name=${selectedColor.name}`}
              id={VISUALIZER_IFRAME_ID}
            />
          ) : null}
        </div>
      </div>
    </Modal>
  );
};

export default ColorVizContent;
